module.exports = __webpack_public_path__ + "img/38ne.b6eb1e58.svg";